// extracted by mini-css-extract-plugin
module.exports = {"max-attempt-reached":"MaximumAttempReached_max-attempt-reached___MEVJ","inline-alert":"MaximumAttempReached_inline-alert__RE_Do","button":"MaximumAttempReached_button__1MrAX"};